// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1VoIe","icon":"styles_icon__3_nDU"};